<template>
    <OverlayRoomSizeInput :top="positionWallInput1[1]"
                          :left="positionWallInput1[0]"
                          :text="'Стена (мм)'"
                          :value-prop="storeConfiguration.getRoomParamByName('frontWallWidth')*1000"
                          :param-name="'frontWallWidth'"
                          v-if="storeConfiguration.getRoomParamByName('frontWallWidth') > 0"/>

    <OverlayRoomSizeInput :top="positionWallInput2[1]"
                          :left="positionWallInput2[0]"
                          :text="'Стена (мм)'"
                          :value-prop="storeConfiguration.getRoomParamByName('leftWallWidth')*1000"
                          :param-name="'leftWallWidth'"
                          v-if="storeConfiguration.getRoomParamByName('leftWallWidth') > 0"/>

    <OverlayRoomSizeInput :top="positionWallInput3[1]"
                          :left="positionWallInput3[0]"
                          :text="'Стена (мм)'"
                          :value-prop="storeConfiguration.getRoomParamByName('rightWallWidth')*1000"
                          :param-name="'rightWallWidth'"
                          v-if="storeConfiguration.getRoomParamByName('rightWallWidth') > 0"/>

    <OverlayRoomSizeInput :top="positionWallInput4[1]"
                          :left="positionWallInput4[0]"
                          :text="'Стена (мм)'"
                          :value-prop="storeConfiguration.getRoomParamByName('backWallWidth')*1000"
                          :param-name="'backWallWidth'"
                          v-if="storeConfiguration.getRoomParamByName('backWallWidth') > 0"/>

    <OverlayRoomType :top="positionRoomType[1]"
                     :left="positionRoomType[0]"/>
    <OverlayRoomConfirm :top="positionRoomConfirm[1]"
                        :left="positionRoomConfirm[0]"
                        :text="'Готово'"/>

    <OverlayRoomConfigButton :top="configurePositions.topRight[1]"
                             :left="configurePositions.topRight[0]"
                             :svg="'SVGResizeH'"
                             :transparent=true
                             :type="'topRight'"/>

    <OverlayRoomConfigButton :top="configurePositions.centerLeft[1]"
                             :left="configurePositions.centerLeft[0]"
                             :svg="wallSVG('leftWallWidth')"
                             :type="'centerLeft'"
                             v-on:click="switchWallWidth('leftWallWidth')"/>

    <OverlayRoomConfigButton :top="configurePositions.centerRight[1]"
                             :left="configurePositions.centerRight[0]"
                             :svg="wallSVG('rightWallWidth')"
                             :type="'centerRight'"
                             v-on:click="switchWallWidth('rightWallWidth')"/>

    <OverlayRoomConfigButton :top="configurePositions.bottomLeft[1]"
                             :left="configurePositions.bottomLeft[0]"
                             :svg="'SVGResizeV'"
                             :transparent=true
                             v-if="storeConfiguration.getRoomParamByName('leftWallWidth') > 0"
                             :type="'bottomLeft'"/>

    <OverlayRoomConfigButton :top="configurePositions.bottomCenter[1]"
                             :left="configurePositions.bottomCenter[0]"
                             :svg="wallSVG('backWallWidth')"
                             :type="'bottomCenter'"
                             v-if="storeConfiguration.getRoomParamByName('rightWallWidth') > 0 || storeConfiguration.getRoomParamByName('leftWallWidth') > 0"
                             v-on:click="switchWallWidth('backWallWidth')"/>

    <OverlayRoomConfigButton :top="configurePositions.bottomRight[1]"
                             :left="configurePositions.bottomRight[0]"
                             :svg="'SVGResizeV'"
                             :transparent=true
                             v-if="storeConfiguration.getRoomParamByName('rightWallWidth') > 0"
                             :type="'bottomRight'"/>
  <OverlayRoomConfigButton :top="configurePositions.backRightWall[1]"
                           :left="configurePositions.backRightWall[0]"
                           :svg="'SVGResizeH'"
                           :transparent=true
                           v-if="backWallSliderActive"
                           :type="'backRightWall'"/>
</template>

<script>
import OverlayRoomSizeInput from '@/UI/Components/ComponentsOverlay/OverlayRoomSizeInput.vue';
import OverlayRoomType from '@/UI/Components/ComponentsOverlay/OverlayRoomType.vue';
import OverlayRoomConfirm from '@/UI/Components/ComponentsOverlay/OverlayRoomConfirm.vue';
import { useUIOnlyStore } from '@/Store/storeUI';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import OverlayRoomConfigButton from '@/UI/Components/ComponentsOverlay/OverlayRoomConfigButton.vue';
import { backWallMinDistance } from '@/Constants/common';

export default {
    name: 'OverlayRoomSetup',
    components: {
        OverlayRoomConfigButton,
        OverlayRoomConfirm,
        OverlayRoomType,
        OverlayRoomSizeInput,
    },
    setup() {
        const storeUI = useUIOnlyStore();
        const storeConfiguration = useConfigurationStore();
        return {
            storeUI,
            storeConfiguration,
        };
    },
    methods: {
        wallSVG(wallParam) {
            const width = this.storeConfiguration.getRoomParamByName(wallParam);
            if (width > 0) {
                return 'SVGMinusButton';
            }
            return 'SVGPlusButton';
        },
        switchWallWidth(wallParam) {
            const width = this.storeConfiguration.getRoomParamByName(wallParam);
            if (width > 0) {
                this.storeConfiguration.setRoomParamByName(wallParam, 0);
                return;
            }
            this.storeConfiguration.setRoomParamByName(wallParam, 1);
        },
    },
    computed: {
        backWallSliderActive()
        {
          return (this.storeConfiguration.getRoomParamByName('backWallWidth') > 0 &&
              Math.abs(this.storeConfiguration.getRoomParamByName('backWallWidth') -
              this.storeConfiguration.getRoomParamByName('frontWallWidth')) > backWallMinDistance);
        },
        positionWallInput1() {
            return this.storeUI.getUIPosition('wallInput1');
        },
        positionWallInput2() {
            return this.storeUI.getUIPosition('wallInput2');
        },
        positionWallInput3() {
            return this.storeUI.getUIPosition('wallInput3');
        },
        positionWallInput4() {
            return this.storeUI.getUIPosition('wallInput4');
        },
        positionRoomType() {
            return this.storeUI.getUIPosition('roomType');
        },
        positionRoomConfirm() {
            return this.storeUI.getUIPosition('roomConfirm');
        },
        configurePositions() {
            return this.storeUI.getConfigurationUIPositions;
        },
    },
};
</script>

<style scoped lang="scss">

</style>
